var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useMemo } from "react";
import { Select } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { volumeOptionLabel } from "../../utils/volumeWindow";
import { CURRENT_VOLUME_TO_CREATE } from "../../hooks/useIssueVolumeChoice";
import css from "./IssueVolumeRow.module.css";
export var IssueVolumeRow = function (_a) {
    var volumes = _a.volumes, value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    var options = useMemo(function () {
        var volumeOptions = volumes.map(function (volume) { return ({
            value: volume.id,
            label: volumeOptionLabel(volume, formatMessage),
        }); });
        return volumes.some(function (volume) { return volume.current; })
            ? volumeOptions
            : __spreadArray([
                {
                    value: CURRENT_VOLUME_TO_CREATE,
                    label: formatMessage({
                        id: "ui-br-legaldeposits.periodicals.volume.option.createCurrent",
                    }),
                }
            ], volumeOptions, true);
    }, [volumes, formatMessage]);
    var handleChange = useCallback(function (e) { return onChange(e.target.value); }, [onChange]);
    return (React.createElement("div", { className: css.row },
        React.createElement(Select, { label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.issue.dialog.volume",
            }), value: value, onChange: handleChange, dataOptions: options, disabled: disabled, required: true }),
        value === CURRENT_VOLUME_TO_CREATE && (React.createElement("p", { className: css.hint }, formatMessage({
            id: "ui-br-legaldeposits.periodicals.volume.option.createCurrentHint",
        })))));
};
